export const IMPORT_CSV_WRONG_SIZE_MESSAGE = "File size limit is 2MB";
export const IMPORT_CSV_FILE_MESSAGE = "Please upload a CSV file."
export const IMPORT_CSV_FILE_DESCRIPTION = 'Upload your file here'
